import axios from "axios";
import _ from "lodash";
import { buildApiOptions } from "./apiConstants";
import Md5 from "crypto-js/md5";
const service = axios.create();
const apiPromises = {};
const getRequestKey = (path, contentType, params, data, opts) => {
  let str = `${path}${contentType}${params ? JSON.stringify(params) : ""}${data ? JSON.stringify(data) : ""}${opts ? JSON.stringify(opts) : ""}`;
  return Md5(str).toString();
};
let cancel;
export const abortSiteApi = () => {
  cancel && cancel();
  cancel = null;
};
export const sa = (path, contentType) => {
  return async (params, data, opts) => {
    const key = getRequestKey(path, contentType, params, data, opts);
    if (apiPromises[key]) {
      const { data } = await apiPromises[key];
      return data;
    } else {
      let options = buildApiOptions(path, contentType, params, data, opts);
      _.merge(options, {
        cancelToken: new axios.CancelToken(c => {
          cancel = c;
        })
      });
      apiPromises[key] = service.request(options);
      const { data } = await apiPromises[key];
      delete apiPromises[key];
      return data;
    }
  };
};
